@if (chartOptions.series) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    style="width: 100%; height: 320px; display: block"
  ></highcharts-chart>
}
